import type { ChangeEvent } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import type { MatchSearch } from 'api/generated'
import { Button } from 'components/ui/button'
import { Input } from 'components/ui/input'
import { Save, Trash2 } from 'lucide-react'

export interface MatchesColumnsProps {
  onSetMatchResult: (matchId: number, result: string) => void
  onUpdateMatch: (match: MatchSearch) => void
  onDeleteMatch: (matchId: number) => void
}

type Player = MatchSearch['first_winner']

const playerName = (player: Player) => player?.name ?? '-'

export const matchesColumns = (
  props: MatchesColumnsProps
): ColumnDef<MatchSearch>[] => [
  {
    accessorKey: 'id',
    header: 'ID',
    cell: ({ row }) => <div className='text-center'>{row.original.id}</div>,
  },
  {
    id: 'details',
    header: 'Dettagli',
    cell: ({ row }) => (
      <div>
        <strong>Competizione:</strong> {row.original.competition.name}
        <br />
        <strong>Torneo:</strong> {row.original.tournament.fit_tournament_id}
        <br />
        <strong>Tabellone:</strong> {row.original.draw.fit_draw_id}
      </div>
    ),
  },
  {
    id: 'winners',
    header: 'Vincitori',
    cell: ({ row }) => (
      <ol>
        <li>{playerName(row.original.first_winner)}</li>
        <li>{playerName(row.original.second_winner)}</li>
      </ol>
    ),
  },
  {
    id: 'losers',
    header: 'Perdenti',
    cell: ({ row }) => (
      <ol>
        <li>{playerName(row.original.first_loser)}</li>
        <li>{playerName(row.original.second_loser)}</li>
      </ol>
    ),
  },
  {
    accessorKey: 'result',
    header: 'Risultato',
    cell: ({ row }) => {
      const handleResultChange = (event: ChangeEvent<HTMLInputElement>) => {
        props.onSetMatchResult(row.original.id, event.target.value)
      }

      return (
        <div className='flex items-center'>
          <Input
            value={row.original.result ?? ''}
            onChange={handleResultChange}
            className='mr-2 w-24 text-center' // Adjust width as needed
          />
          <Button size='sm' onClick={() => props.onUpdateMatch(row.original)}>
            <Save />
          </Button>
        </div>
      )
    },
  },
  {
    id: 'delete',
    header: '',
    cell: ({ row }) => (
      <div className='text-center'>
        <Button
          size='sm'
          variant='destructive'
          onClick={() => {
            if (
              window.confirm('Sei sicuro di voler eliminare questa partita?')
            ) {
              props.onDeleteMatch(row.original.id)
            }
          }}
        >
          <Trash2 />
        </Button>
      </div>
    ),
  },
]
